import { createSlice } from '@reduxjs/toolkit';
import { BusinessProfileConstants, userConstants } from '../_constants';

const initialState = {
  data: null,
  editInfo: false,
  dataRequest: [],
  isLoading: false,
  updateSuccess: false,
  redirect: false,
  flags: {},
  users: [],
  news: [],
  isLoadingModal: false,
  tabApplicants: {},
  tabVacancies: {},
  isLoadingReport: false,
  isOk: false,
  error: null,
};

const businessProfileSlice = createSlice({
  name: 'businessProfileReducers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(BusinessProfileConstants.IS_OK, (state, action) => {
        state.isOk = action.payload;
      })
      .addCase(BusinessProfileConstants.SET_TAB_VACANCIES, (state, action) => {
        state.tabVacancies = action.payload;
      })
      .addCase(BusinessProfileConstants.SET_TAB_APPLICANTS, (state, action) => {
        state.tabApplicants = action.payload;
      })
      .addCase(BusinessProfileConstants.IS_LOADING_REPORT, (state, action) => {
        state.isLoadingReport = action.payload;
      })
      .addCase(BusinessProfileConstants.UPDATE_NEWS, (state, action) => {
        state.news = action.payload;
      })
      .addCase(BusinessProfileConstants.UPDATE_USERS, (state, action) => {
        state.users = action.payload;
      })
      .addCase(BusinessProfileConstants.EDIT_INFO, (state, action) => {
        state.editInfo = action.payload;
      })
      .addCase(BusinessProfileConstants.REDIRECT, (state, action) => {
        state.redirect = action.payload;
      })
      .addCase(BusinessProfileConstants.UPDATE_DATA_FLAGS, (state, action) => {
        state.flags = action.payload;
      })
      .addCase(BusinessProfileConstants.UPDATE_DATA, (state, action) => {
        state.data = action.payload;
      })
      .addCase(BusinessProfileConstants.IS_LOADING, (state, action) => {
        state.isLoading = action.payload;
      })
      .addCase(BusinessProfileConstants.IS_LOADING_MODAL, (state, action) => {
        state.isLoadingModal = action.payload;
      })
      .addCase(
        BusinessProfileConstants.UPDATE_DATA_REQUEST,
        (state, action) => {
          state.dataRequest = action.payload;
        }
      )
      .addCase(BusinessProfileConstants.UPDATE_SUCCESS, (state, action) => {
        state.updateSuccess = action.payload;
      })
      .addCase(BusinessProfileConstants.UPDATE_ERROR, (state, action) => {
        state.error = action.payload;
      })
      .addCase(userConstants.LOGOUT, () => initialState);
  },
});

export default businessProfileSlice.reducer;
